// hooks/usePermissions.js
import { useCallback } from "react";
import { useSelector } from "react-redux";

const userPermissionData = [
  { role: "Admin", permissions: "all" },
  {
    role: "Admin-a",
    permissions: [
      { module: "inquiry", value: ["view", "create", "alter", "delete", "quick-edit"] },
      { module: "user", value: ["view", "create", "alter", "delete"] },
      { module: "queries", value: ["view", "create", "alter", "delete", "assuser"] },
      { module: "operation", value: ["view", "create", "alter", "delete", "change-request", "verify"] },
      { module: "verified-leads", value: ["view", "create", "alter", "delete"] },
      { module: "easo-guests", value: ["view"] },
      { module: "confirm-booking", value: ["view", "assign"] },
      { module: "attendance", value: ["view"] },
      { module: "leaves", value: ["view"] },
      { module: "holidays", value: ["view"] },
      { module: "itinerary-store", value: ["view", "create", "alter", "delete"] },
      { module: "destination-itinerary-store", value: ["view", "create", "alter", "delete"] },
      { module: "locations", value: ["view", "create", "alter", "delete"] },
    ],
  },
  {
    role: "HR Management",
    permissions: [
      { module: "user", value: ["view", "create", "alter", "delete"] },
      { module: "attendance", value: ["view", "create", "alter", "delete"] },
      { module: "leaves", value: ["view", "create", "alter", "delete"] },
      { module: "teams", value: ["view", "create", "alter", "delete"] },
      { module: "holidays", value: ["view", "create", "alter", "delete"] },
      { module: "hr-management", value: ["view", "create", "alter", "delete"] },
      { module: "dashboard", value: ["view"] },
      { module: "logout", value: ["view"] },
      { module: "announcements", value: ["view", "create", "alter", "delete"] },
    ],
  },
  {
    role: "Sales Manager",
    permissions: [
      { module: "inquiry", value: ["view", "create", "alter", "quick-edit"] },
      { module: "queries", value: ["view", "create", "alter", "assuser"] },
      { module: "operation", value: ["view", "create", "alter", "change-request", "verify"] },
      { module: "verified-leads", value: ["view", "create", "alter"] },
      { module: "easo-guests", value: ["view"] },
      { module: "confirm-booking", value: ["view"] },
      { module: "dashboard", value: ["view"] },
      { module: "hotel", value: ["view", "alter"] },
      { module: "attendance", value: ["view"] },
      { module: "leaves", value: ["view"] },
      { module: "holidays", value: ["view"] },
      { module: "itinerary-store", value: ["view", "create", "alter", "delete"] },
      { module: "destination-itinerary-store", value: ["view", "create", "alter", "delete"] },
      { module: "announcements", value: ["view"] },
    ],
  },
  {
    role: "Sales Team Lead",
    permissions: [
      { module: "inquiry", value: ["view", "create", "alter", "delete", "quick-edit", "verify"] },
      { module: "queries", value: ["view", "create", "alter", "delete", "assuser", "quick-edit"] },
      { module: "user", value: ["view"] },
      { module: "operation", value: ["view", "create", "alter", "change-request", "verify"] },
      { module: "verified-leads", value: ["view", "create", "alter"] },
      { module: "easo-guests", value: ["view"] },
      { module: "confirm-booking", value: ["view", "assign"] },
      { module: "dashboard", value: ["view"] },
      { module: "packages", value: ["view", "create", "alter"] },
      { module: "ctg-packages", value: ["view", "create", "alter"] },
      { module: "places", value: ["view", "create", "alter"] },
      { module: "Vehicles", value: ["view"] },
      { module: "itinerary-cards", value: ["view", "create", "alter"] },
      { module: "teams", value: ["view"] },
      { module: "hotel", value: ["view", "alter"] },
      { module: "attendance", value: ["view"] },
      { module: "leaves", value: ["view"] },
      { module: "holidays", value: ["view"] },
      { module: "itinerary-store", value: ["view", "create", "alter", "delete"] },
      { module: "destination-itinerary-store", value: ["view", "create", "alter", "delete"] },
      { module: "announcements", value: ["view"] },
    ],
  },
  {
    role: "Operation Manager",
    permissions: [
      { module: "queries", value: ["view", "create", "alter", "assuser"] },
      { module: "operation", value: ["view", "create", "alter", "change-request", "verify"] },
      { module: "easo-guests", value: ["view"] },
      { module: "confirm-booking", value: ["view", "assign"] },
      { module: "dashboard", value: ["view"] },
      { module: "hotel", value: ["view", "alter", "add-hotel", "delete"] },
      { module: "attendance", value: ["view"] },
      { module: "leaves", value: ["view"] },
      { module: "holidays", value: ["view"] },
      { module: "announcements", value: ["view"] },
    ],
  },
  {
    role: "Sales Executive",
    permissions: [
      { module: "inquiry", value: ["view", "quick-edit", "verify"] },
      { module: "queries", value: ["view", "create", "alter"] },
      { module: "verified-leads", value: ["view"] },
      { module: "easo-guests", value: ["view"] },
      { module: "dashboard", value: ["view"] },
      { module: "logout", value: ["view"] },
      { module: "operation", value: ["change-request"] },
      { module: "attendance", value: ["view"] },
      { module: "leaves", value: ["view"] },
      { module: "holidays", value: ["view"] },
      { module: "itinerary-store", value: ["view", "create", "alter", "delete"] },
      { module: "hotel", value: ["view", "alter", "add-hotel", "delete"] },
      { module: "destination-itinerary-store", value: ["view", "create", "alter", "delete"] },
      { module: "announcements", value: ["view"] },
    ],
  },
  {
    role: "Operation",
    permissions: [
      // { module: "user", value: ["view", "create", "alter", "delete"] },
      { module: "queries", value: ["view", "create", "alter"] },
      { module: "operation", value: ["view", "create", "change-request"] },
      { module: "confirm-booking", value: ["view"] },
      { module: "dashboard", value: ["view"] },
      { module: "packages", value: ["view", "create", "alter", "delete", "alter-image", "basic-verify"] },
      { module: "hotel", value: ["view", "alter", "add-hotel", "delete"] },
      { module: "attendance", value: ["view"] },
      { module: "leaves", value: ["view"] },
      { module: "holidays", value: ["view"] },
      { module: "announcements", value: ["view"] },
    ],
  },
  {
    role: "Operation Executive",
    permissions: [
      { module: "queries", value: ["view", "create", "alter"] },
      { module: "operation", value: ["view", "create", "change-request"] },
      { module: "confirm-booking", value: ["view"] },
      { module: "dashboard", value: ["view"] },
      { module: "packages", value: ["view", "create", "alter", "delete", "alter-image", "basic-verify"] },
      { module: "hotel", value: ["view", "alter", "add-hotel", "delete"] },
      { module: "attendance", value: ["view"] },
      { module: "leaves", value: ["view"] },
      { module: "holidays", value: ["view"] },
      { module: "announcements", value: ["view"] },
    ],
  },
  {
    role: "FrontDesk",
    permissions: [
      { module: "inquiry", value: ["view"] },
      { module: "queries", value: ["view", "create"] },
      { module: "verified-leads", value: ["view", "create"] },
      { module: "easo-guests", value: ["view"] },
      { module: "dashboard", value: ["view"] },
      { module: "attendance", value: ["view"] },
      { module: "leaves", value: ["view"] },
      { module: "holidays", value: ["view"] },
      { module: "announcements", value: ["view"] },
    ],
  },
  {
    role: "User",
    permissions: [
      { module: "inquiry", value: ["view"] },
      { module: "queries", value: ["view", "create", "alter"] },
      { module: "verified-leads", value: ["view"] },
      { module: "dashboard", value: ["view"] },
      { module: "logout", value: ["view"] },
      { module: "operation", value: ["change-request"] },
      { module: "attendance", value: ["view"] },
      { module: "leaves", value: ["view"] },
      { module: "holidays", value: ["view"] },
      { module: "announcements", value: ["view"] },
    ],
  },
  {
    role: "EsoOperator",
    permissions: [
      { module: "dashboard", value: ["view"] },
      { module: "packages", value: ["view", "create", "alter", "delete", "alter-image"] },
      { module: "ctg-packages", value: ["view", "create", "alter", "delete", "add-packages"] },
      { module: "logout", value: ["view"] },
      { module: "places", value: ["view", "create", "alter", "delete", "alter-ranking", "alter-image", "add-packages"] },
      { module: "hotel", value: ["view", "alter"] },
      { module: "operation", value: ["view", "alter"] },
      { module: "attendance", value: ["view"] },
      { module: "leaves", value: ["view"] },
      { module: "holidays", value: ["view"] },
      { module: "announcements", value: ["view"] },
    ],
  },
  {
    role: "esoride Executive",
    permissions: [
      { module: "dashboard", value: ["view"] },
      { module: "logout", value: ["view"] },
      { module: "attendance", value: ["view"] },
      { module: "leaves", value: ["view"] },
      { module: "holidays", value: ["view"] },
      { module: "announcements", value: ["view"] },
    ],
  },
];

const usePermissions = () => {
  const userRole = useSelector((state) => state.tokens?.user?.permission);
  const isOfficeEmp = useSelector((state) => state.tokens?.user?.isOfficeEmp);
  const isTeamLeader = useSelector(
    (state) => Boolean(state.tokens?.user?.isTeamLeader || state.tokens?.user?.is_leader || state.tokens?.user?.isLeader)
  );

  return useCallback(
    (moduleName, permissionType) => {
      if (isTeamLeader && moduleName === "hr-management" && permissionType === "view") {
        return true;
      }

      if (isOfficeEmp && userRole !== "HR Management" && userRole !== "Admin" && userRole !== "Admin-a") {
        const allowedModules = ["hr-management", "attendance", "leaves", "teams", "logout", "announcements"];
        if (!allowedModules.includes(moduleName)) return false;
        if (permissionType === "view") return true;
        return false;
      }

      if (userRole?.toLowerCase() === "admin") return true;
      const roleData = userPermissionData.find((role) => role.role?.toLowerCase() === userRole?.toLowerCase());
      if (!roleData) return false;
      if (roleData.permissions === "all") return true;

      const modulePermissions = roleData.permissions.find((mod) => mod.module === moduleName);
      return modulePermissions?.value.includes(permissionType) || false;
    },
    [userRole, isOfficeEmp, isTeamLeader]
  );
};

export default usePermissions;
